<template>
    <div class="keystone-market-research-page">
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Home Improvement Market Research
                </div>
                <div class="logo">
                    <img src="/images/powered-by-logo-keystone.png">
                </div>
            </div>
            <h1 class="keystone-title">
              Manage Keystone Marketing Downloads
            </h1>
          <div class="box-content">
            <div class="mb-3 align-right">
              <a href="/keystone-downloads/create" class="btn-primary">Add New</a>
            </div>
            <div class="content-uploads-list-view" v-show="keystone_marketing_downloads.length > 0" :class="{ 'user_can_manage_downloads' : true }">
              <table class="table _lined">
                <tbody>
                <tr v-for="keystone_marketing_download in keystone_marketing_downloads">
                  <td class="content-uploads-list-view-image">
                    <div>
                      <img :src="`${$aws_bucket_url}${keystone_marketing_download.thumbnail_url}`" @error="imageFallbackIcon">
                    </div>
                  </td>
                  <td class="content-uploads-list-view-name">
                    {{ keystone_marketing_download.name }}
                  </td>
                  <td class="content-uploads-list-view-buttons">
                    <a @click.prevent="deleteItem(keystone_marketing_download.id)" class="btn-danger">
                      <i class="fal fa-trash-alt"></i>
                    </a>
                    <a class="btn-primary" @click="downloadItem(keystone_marketing_download.id)">
                      <strong>Download</strong>
                    </a>
                    <a :href="'/keystone-downloads/edit/' + keystone_marketing_download.id" class="btn-primary">
                      <i class="fal fa-pencil"></i>
                    </a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <template v-if="!loading && total_count > 0">
              <div class="pagination-bar wrapper mb-3 mt-3">
                <div class="row">
                  <div class="col">
                    <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                      class="fa fa-caret-left"></i></a>
                    <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                    <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                       class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                  </div>
                  <div class="col align-right">
                    <div class="mt-1 mb-1">
                      {{ total_count }} results found
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="!loading && total_count === 0">
              <strong class="block mt-3 p-3">
                No Results Found
              </strong>
            </template>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            keystone_marketing_downloads: [],
            loading: true,
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            limit: 24,
            sort_by: '',
        }
    },
    async mounted() {
      this.loadKeystoneDownloads();
    },
    methods: {
      loadKeystoneDownloads: _.debounce(function() {
        this.loading = true;
        axios.post('/keystone-downloads/loadKeystoneDownloadsForAdmin', {
          search_query: this.search_query,
          sort_by: this.sort_by,
          page_number: this.current_page,
          limit: this.limit,
        }).then((response) => {
          this.keystone_marketing_downloads = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
          this.loading = false;
        });
      }, 250),
      deleteItem(id) {
        Swal.fire({
          title: 'Are you sure you want to remove this item?',
          text: 'This action cannot be undone.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Confirm',
        }).then((result) => {
          if (result.isConfirmed) {
            this.loading = true;
            axios.post('/keystone-downloads/delete', {
              'keystone_marketing_download_id': id,
            }).then((response) => {
              this.current_page = 1;
              this.loadKeystoneDownloads();
              Swal.fire({
                title: 'Upload Deleted',
                icon: 'success',
              });
            });
          }
        });
      },
      downloadItem(item_id) {
        this.file_box_open = false;
        this.open_file = {};
        axios.get( `/keystone-downloads/download-item/${item_id}`).then((response) => {
          window.location.href = response.data;
        });
      },
      imageFallbackIcon(event) {
        event.target.src = '/images/content-uploads-thumbnail-fallback-icon.png';
      },
      prevPage() {
        this.current_page = this.current_page - 1;
        this.loadKeystoneDownloads();
      },
      nextPage() {
        this.current_page = this.current_page + 1;
        this.loadKeystoneDownloads();
      },
    },
    watch: {
      search_query() {
        this.current_page = 1;
        this.loadKeystoneDownloads();
      },
      sort_by() {
        this.current_page = 1;
        this.loadKeystoneDownloads();
      },
    },
};
</script>
